import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { AlarmDetailsViewContainer } from '../features/Alarm/AlarmDetails'

const AlarmDetails = () => {

    return (
        <Page header='Alarm Details' showNavigateBack>
            <AlarmDetailsViewContainer></AlarmDetailsViewContainer>
        </Page >
    )
}


export default withAITracking(reactPlugin, AlarmDetails);